import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { Price } from '@thd-olt-component-react/price';
import { AddToCart } from '@thd-olt-component-react/add-to-cart';
import { LoadingPlaceholder } from '@thd-olt-component-react/loading-placeholder';
import { Col } from '@thd-olt-component-react/core-ui';
import { FREE_SHIPPING_THRESHOLD } from './appliances/constants';
import { DeliveryMessage } from './appliances/DeliveryMessage';
import './Buybox.style.scss';

const Buybox = ({
  cartOptions,
  cartReqParams,
  finalPriceMessage,
  itemId,
  message,
  onAddToCartClick,
  pricing,
  strikethrough,
  applianceBundle,
  checkedItems,
  storeId
}) => {

  const { channel } = useContext(ExperienceContext);
  const shouldShowFinalPriceMessage = finalPriceMessage && !applianceBundle;
  const shouldShowStrikethrough = strikethrough && !applianceBundle;

  const isApplianceDeliveryFree = (totalPrice) => {
    return totalPrice.pricing?.original >= FREE_SHIPPING_THRESHOLD;
  };

  return (
    <>
      <div className="fbt-buybox__message-price">
        {message
        && (
          <div className="fbt-buybox__message">
            {message.priceMessage}
          </div>
        )}
        <LoadingPlaceholder
          type="text"
          ready={checkedItems.length > 1}
          color="#E0E0E0"
          rows={3}
          style={{ height: 100 }}
        >
          <div className="fbt-buybox__price">
            {shouldShowStrikethrough && <span className="fbt-buybox__strikethrough" />}
            <Price
              basic={applianceBundle}
              channel={channel}
              itemId={itemId}
              large={applianceBundle}
              product={pricing}
              displayEachUom={!applianceBundle}
              storeId={storeId}
            />
            {applianceBundle && <DeliveryMessage freeDelivery={isApplianceDeliveryFree(pricing)} />}
          </div>
        </LoadingPlaceholder>
      </div>
      {shouldShowFinalPriceMessage && (
        <div className="fbt-buybox__final-price-message">See Final Price in Cart</div>
      )}
      <Col nopadding>
        <AddToCart
          cartOptions={cartOptions}
          cartReqParams={cartReqParams}
          onClick={onAddToCartClick}
          outline
          small={false}
        >
          Add Items to Cart
        </AddToCart>
      </Col>
    </>
  );
};

Buybox.propTypes = {
  applianceBundle: PropTypes.bool,
  cartOptions: PropTypes.oneOfType([PropTypes.object]).isRequired,
  cartReqParams: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.shape({})
  ]).isRequired,
  finalPriceMessage: PropTypes.bool,
  itemId: PropTypes.string.isRequired,
  message: PropTypes.oneOfType([PropTypes.object]).isRequired,
  onAddToCartClick: PropTypes.func.isRequired,
  pricing: PropTypes.shape({}).isRequired,
  strikethrough: PropTypes.bool,
  checkedItems: PropTypes.arrayOf(PropTypes.string),
  storeId: PropTypes.string.isRequired
};

Buybox.defaultProps = {
  applianceBundle: false,
  finalPriceMessage: false,
  strikethrough: false,
  checkedItems: [],
};

Buybox.displayName = 'FBTBuybox';

export default Buybox;
